"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutThunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var auth_1 = require("firebase/auth");
var message_1 = require("../../components/dialogs/message");
var auth_persistence_1 = require("../../utils/auth-persistence");
var firebase_1 = require("../../utils/firebase");
var auth_2 = require("../slices/auth");
var message_dialog_1 = require("./message-dialog");
exports.logoutThunk = (0, toolkit_1.createAsyncThunk)("auth/logout", function (_1, _a) { return __awaiter(void 0, [_1, _a], void 0, function (_, _b) {
    var dispatch = _b.dispatch, getState = _b.getState;
    return __generator(this, function (_c) {
        // create a Promise to wait for modal interaction
        return [2 /*return*/, new Promise(function (resolve, reject) {
                dispatch((0, message_dialog_1.showMessageDialogThunk)({
                    header: "Log Out",
                    body: "Are you sure you want to log out?",
                    buttons: [
                        {
                            label: "Cancel",
                            variant: "bordered",
                            type: message_1.EModalMessageButtonType.CANCEL,
                            onClick: function () {
                                reject(message_1.EModalMessageButtonType.CANCEL);
                            },
                        },
                        {
                            label: "Log Out",
                            variant: "solid",
                            type: message_1.EModalMessageButtonType.OK,
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var error_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 3, , 4]);
                                            // 1. Sign out of Firebase first (clears Firebase auth session)
                                            return [4 /*yield*/, (0, auth_1.signOut)(firebase_1.auth)];
                                        case 1:
                                            // 1. Sign out of Firebase first (clears Firebase auth session)
                                            _a.sent();
                                            // 2. Clear the redux store
                                            dispatch((0, auth_2.clearCredentials)());
                                            // 3. Clear ALL auth-related localStorage/sessionStorage
                                            // This includes: firebase_token, firebase_refresh_token, lets_trade_token,
                                            // sky_user_data, access_token, user_data, refresh_token
                                            (0, auth_persistence_1.clearPersistedAuthState)();
                                            // Also clear redux-persist and firebase_user_id marker
                                            localStorage.removeItem("persist:root");
                                            localStorage.removeItem("firebase_user_id");
                                            // 4. Wait for Firebase signOut to propagate before reloading
                                            // This prevents onAuthStateChanged from seeing stale auth state
                                            return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, 500); })];
                                        case 2:
                                            // 4. Wait for Firebase signOut to propagate before reloading
                                            // This prevents onAuthStateChanged from seeing stale auth state
                                            _a.sent();
                                            // 5. Force page refresh to clear FaceTec SDK session and all state
                                            window.location.reload();
                                            resolve("logout");
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_1 = _a.sent();
                                            console.error("Logout error:", error_1);
                                            // Still reload even if Firebase signOut fails
                                            window.location.reload();
                                            reject(error_1);
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); },
                        },
                    ],
                }));
            })];
    });
}); });
